import { Component, css, html, LitElement, property, query } from '@rxdi/lit-html';
import { diffChars, diffCss, diffJson, diffSentences } from 'diff';

export type DiffVersions = 'chars' | 'sentences' | 'words' | 'json';

/**
 * @customElement rx-diff
 */
@Component({
  selector: 'rx-diff',
  style: css`
    span {
      color: 'gray';
      background: 'transparent';
    }
    ins {
      background: #eaf2c2;
      color: #406619;
      text-decoration: none;
    }

    del {
      color: #b30000;
      background: #fadad7;
      text-decoration: 'line-through';
    }

    #display {
      white-space: pre-wrap;
      display: contents;
    }
  `,
  template(this: DiffComponent) {
    return html`<div id="display"></div>`;
  },
})
export class DiffComponent extends LitElement {
  @property({ type: String })
  new: string;

  @property()
  old: string;

  @query('#display')
  display: HTMLDivElement;

  @property({ type: String })
  version: DiffVersions = 'words';

  OnUpdate() {
    this.createDiffElements();
  }

  private createDiffElements() {
    this.display.innerHTML = '';

    if (!this.display) {
      return;
    }
    this.new = this.new ?? '';
    this.old = this.old ?? '';

    const versions = {
      chars: diffChars(this.new, this.old),
      sentences: diffSentences(this.new, this.old),
      words: diffCss(this.new, this.old),
      json: diffJson(this.new, this.old),
    };
    const diff = versions[this.version] ?? diffCss(this.new, this.old);
    const fragment = document.createDocumentFragment();

    const elements = {
      default: 'span',
      added: 'ins',
      removed: 'del',
    };

    const spans = diff.map((part) => {
      const element = part.added ? elements.added : part.removed ? elements.removed : elements.default;
      const span = document.createElement(element);

      span.appendChild(document.createTextNode(part.value));
      return span;
    });

    for (const span of spans) {
      fragment.appendChild(span);
    }

    this.display.appendChild(fragment);
  }
}
